import { I18n } from 'react-redux-i18n-lite';
import { getTaskGrade } from '../services/domain/taskService';
import { PASS_THRESHOLD } from '../const';
import * as taskService from '../services/domain/taskService';

export const getObjectTask = (task, userId) => {
  const studentAttempt = task.studentAttempts?.[userId];
  let actObj = {
    fail: 0,
    pass: 0,
    complete: 0,
    pending: 0,
    total: task.activities?.length
      ? task.activities.filter(act => act.activityType !== 'https://w3id.org/xapi/smart/activity/lesson').length
      : 0,
    comment: (studentAttempt?.evaluation && studentAttempt.evaluation.comment) || ''
  };
  if (task.activitiesState?.length && task.bookId) {
    task.activitiesState.map(element => {
      if (element.complete.find(c => c === userId)) ++actObj.complete;
      else if (element.pass.find(p => p === userId)) ++actObj.pass;
      else if (element.fail.find(f => f === userId)) ++actObj.fail;
      else actObj.pending = actObj.pending + 1;
    });
  } else if (!task.bookId || !task.activitiesState?.length) {
    const findUser = task.users.find(user => user._id === userId);
    if (!findUser || typeof findUser.passed === 'undefined') ++actObj.complete;
    else if (findUser.passed) ++actObj.pass;
    else ++actObj.fail;
  }
  return actObj;
};

export const getGradeMark = grade => {
  let gradeMark = '';
  if (grade > 90) {
    gradeMark = I18n.t('tasks.gradeIcon.excellent');
  } else if (grade > 60) {
    gradeMark = I18n.t('tasks.gradeIcon.good');
  } else if (grade > 40) {
    gradeMark = I18n.t('tasks.gradeIcon.acceptable');
  } else if (grade) {
    gradeMark = I18n.t('tasks.gradeIcon.poor');
  } else {
    gradeMark = I18n.t('tasks.gradeIcon.veryPoor');
  }

  return gradeMark;
};

export const gradeActivity = (task, objectProjectTask, user) => {
  let gradeResult = null;
  if (objectProjectTask.total) {
    gradeResult = task.activitiesState.length ? (objectProjectTask.pass / objectProjectTask.total) * 100 : null;
  } else {
    gradeResult = getTaskGrade(task, user._id);
  }
  return gradeResult;
};

export const resultActivitiesStudents = (task, user) => {
  let columnNames = [
    I18n.t('tasks.csvHeader.firstName'),
    I18n.t('tasks.csvHeader.lastName'),
    I18n.t('tasks.csvHeader.evaluation'),
    I18n.t('tasks.csvHeader.comments')
  ];
  const getActivitiesSmart = task.activities.length
    ? task.activities.filter(
        act =>
          act.activityType !== 'https://w3id.org/xapi/smart/activity/no-interactive' &&
          act.activityType !== 'https://w3id.org/xapi/smart/activity/lesson'
      ).length
    : false;
  if (getActivitiesSmart) {
    columnNames = [
      I18n.t('tasks.csvHeader.firstName'),
      I18n.t('tasks.csvHeader.lastName'),
      I18n.t('tasks.csvHeader.activities'),
      I18n.t('tasks.csvHeader.evaluation')
    ];
  }
  const objectProjectTask = getObjectTask(task, user._id);
  const grade = taskService.getTaskGrade(task, user._id);
  const statusText = (() => {
    if (isGrayState(task, objectProjectTask, user._id)) {
      return I18n.t('tasks.gradeIcon.pendingToDo');
    }
    if (isPurpleState(task, objectProjectTask, grade, user._id)) {
      return I18n.t('tasks.gradeIcon.pending');
    }
    if (grade !== null && (isRedState(task, grade, objectProjectTask) || isGreenState(task, grade, objectProjectTask))) {
      return getGradeMark(grade);
    }

    return I18n.t('tasks.gradeIcon.pendingToDo');
  })();
  const activitiesState =
    objectProjectTask.total > 0
      ? objectProjectTask.pass + objectProjectTask.fail === 0 || grade === null
        ? '?/' + objectProjectTask.total
        : objectProjectTask.pass + objectProjectTask.fail + '/' + objectProjectTask.total
      : '';
  let result = {
    [columnNames[0]]: user.name,
    [columnNames[1]]: user.surname,
    [columnNames[2]]: activitiesState,
    [columnNames[3]]: statusText
  };
  if (!activitiesState) {
    result = {
      [columnNames[0]]: user.name,
      [columnNames[1]]: user.surname,
      [columnNames[2]]: statusText,
      [columnNames[3]]: objectProjectTask.comment
    };
  }
  return result;
};

export const getStudentTaskAttempt = (task = {}, studentId) => {
  if (!task || !task.studentAttempts) {
    return undefined;
  }
  return task.studentAttempts[studentId];
};

export const hasPendingResponse = (task = {}, studentId) => {
  const studentAttempt = getStudentTaskAttempt(task, studentId);
  const responses = studentAttempt && Array.isArray(studentAttempt.responses) ? studentAttempt.responses : [];
  const lastResponse = responses.length > 0 ? responses[responses.length - 1] : undefined;

  return Boolean(lastResponse && lastResponse.evaluation === undefined);
};

export const isContentTask = task => Array.isArray(task?.activitiesState) && task.activitiesState.length > 0;

export const isContentTaskComplete = (task = {}, objectProjectTask = {}) => {
  if (!isContentTask(task)) {
    return false;
  }

  const total = typeof objectProjectTask.total === 'number' ? objectProjectTask.total : 0;
  const pass = typeof objectProjectTask.pass === 'number' ? objectProjectTask.pass : 0;
  const fail = typeof objectProjectTask.fail === 'number' ? objectProjectTask.fail : 0;
  // actividades abiertas sin evaluar
  const complete = typeof objectProjectTask.complete === 'number' ? objectProjectTask.complete : 0;
  const completed = pass + fail + complete;

  return total > 0 && completed >= total;
};

export const isPurpleState = (task, objectProjectTask, grade, studentId) => {
  if (hasPendingResponse(task, studentId)) {
    return true;
  }
  if (isContentTask(task) && isContentTaskComplete(task, objectProjectTask)) {
    // actividades abiertas sin evaluar
    const complete = typeof objectProjectTask.complete === 'number' ? objectProjectTask.complete : 0;
    return complete > 0 || grade === null;
  }

  return false;
};

export const isGrayState = (task, objectProjectTask, studentId) => {
  const projectTask = objectProjectTask || {};

  if (isContentTask(task) && !isContentTaskComplete(task, projectTask)) {
    return true;
  }

  const studentAttempt = getStudentTaskAttempt(task || {}, studentId) || {};
  const canStudentRepeat = studentAttempt.canStudentRepeat === true;

  if (canStudentRepeat && !hasPendingResponse(task, studentId)) {
    return true;
  }

  return false;
};

export const isRedState = (task, grade, objectProjectTask) => {
  if (isContentTask(task)) {
    const projectTask = objectProjectTask || {};
    const pass = typeof projectTask.pass === 'number' ? projectTask.pass : 0;
    const fail = typeof projectTask.fail === 'number' ? projectTask.fail : 0;
    return pass + fail > 0 && grade !== null && grade < PASS_THRESHOLD;
  } else {
    return grade !== null && grade < PASS_THRESHOLD;
  }
};

export const isGreenState = (task, grade, objectProjectTask) => {
  if (isContentTask(task)) {
    const projectTask = objectProjectTask || {};
    const pass = typeof projectTask.pass === 'number' ? projectTask.pass : 0;
    const fail = typeof projectTask.fail === 'number' ? projectTask.fail : 0;
    return pass + fail > 0 && grade !== null && grade >= PASS_THRESHOLD;
  } else {
    return grade !== null && grade >= PASS_THRESHOLD;
  }
};
